'use strict';

var React = require('react');

var SvgDataVisualizationMajor = function SvgDataVisualizationMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.75a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8a.75.75 0 0 0-1.5 0v2.25a.75.75 0 0 0 1.5 0v-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.25 4.25a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5v6a3 3 0 0 1-2.877 2.998l.588 1.765a.75.75 0 1 1-1.422.474l-.746-2.237h-3.086l-.746 2.237a.75.75 0 1 1-1.423-.474l.589-1.765a3 3 0 0 1-2.877-2.998v-6a.75.75 0 0 1-.75-.75Zm2.25.75h9v6a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6Z"
  }));
};
SvgDataVisualizationMajor.displayName = "DataVisualizationMajor";

exports.SvgDataVisualizationMajor = SvgDataVisualizationMajor;
